import { Component, inject, signal } from "@angular/core"
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms"
import { Router, RouterModule } from "@angular/router"

import { Button } from "primeng/button"
import { InputText } from "primeng/inputtext"

import { AuthPasswordApi } from "@logick/core-api"

@Component({
  selector: "app-forgot-password-page",
  imports: [ReactiveFormsModule, RouterModule, InputText, Button],
  templateUrl: "./forgot-password.page.html",
})
export class ForgotPasswordPage {

  private fb = inject(FormBuilder)
  private router = inject(Router)
  private authPasswordApi = inject(AuthPasswordApi)

  forgotForm: FormGroup = this.fb.group({
    login: ["", [Validators.required]],
  })

  loading = signal(false)
  apiError = signal<string | null>(null)

  submitForm() {
    if (this.loading() || !this.forgotForm.valid) {
      return
    }

    this.loading.set(true)
    this.apiError.set(null)

    this.authPasswordApi.sendPasswordResetEmail({
      username: this.forgotForm.get("login")?.value,
    }).subscribe({
      next: () => {
        this.router.navigate(["/password-validation"])
      },
      error: () => {
        this.loading.set(false)
        this.apiError.set("Impossible d'envoyer le lien. Vérifiez votre identifiant.")
      },
    })
  }
}
